import i18n, { use as i18nUse } from 'i18next'
import { initReactI18next } from 'react-i18next'

import { de, enUS, ru } from '@shared/config/locales'

const DEFAULT_LANG = 'enUS'

i18nUse(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    // debug: true,

    bindI18n: 'loaded languageChanged',
    bindI18nStore: 'added',
    useSuspense: true,

    resources: { de, enUS, ru },
    supportedLngs: ['de', 'enUS', 'ru'],

    fallbackLng: DEFAULT_LANG,

    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  })

export default i18n
